import { TypeKeys, ActionTypes } from '../actions/index';
import { getGoalFromSlug, getLevelFromSlug } from '../global/utils';

const getInitialState = (): PlansState => {
  return {
    activePlanSlug: null,
    activePlanLoaded: false,
    selectedGoal: null,
    selectedLevel: null,
  };
};

const plans = (state = getInitialState(), action: ActionTypes): PlansState => {
  switch (action.type) {
    case TypeKeys.SET_USER_DOC: {
      const activePlanSlug =
        action.userDoc &&
        action.userDoc.plan &&
        action.userDoc.plan.currentPlanSlug
          ? action.userDoc.plan.currentPlanSlug
          : null;
      return {
        ...state,
        activePlanSlug,
        activePlanLoaded: true,
        selectedGoal: getGoalFromSlug(activePlanSlug),
        selectedLevel: getLevelFromSlug(activePlanSlug),
      };
    }
    case TypeKeys.SET_SELECTED_PLAN_SLUG: {
      const activePlanSlug = action.slug;
      return {
        ...state,
        activePlanSlug,
        selectedGoal: getGoalFromSlug(activePlanSlug),
        selectedLevel: getLevelFromSlug(activePlanSlug),
      };
    }
    case TypeKeys.SIGN_OUT: {
      return { ...getInitialState() };
    }
  }
  return state;
};

export default plans;
